module.exports = __webpack_public_path__ + "img/11.ae670185.jpg";